var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('equipment-card-base',{attrs:{"item":_vm.item}},[(_vm.item.InLcp)?_c('v-row',[_c('div',{staticClass:"heading h3 text-text"},[_vm._v(_vm._s(_vm.item.LcpName))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }